<template>
  <div>
    <span :style="{'font-size':'15px',margin:'0 4px','font-weight':'bold'}">{{tableName}}</span>
    <a-table
      :key="tableName"
      :columns="columns"
      :data-source="tableData"
      :pagination="false"
      :style="{padding:'0 0 8vh 0'}"
    >
      <span slot="download" slot-scope="downloadUrl">
        <a-button type="primary" @click="download(downloadUrl)">
          <a-icon type="download" />
        </a-button>
      </span>
      <span slot="popover" slot-scope="text">
        <a-popover title="声明">
          <template slot="content">
            <p>{{text}}</p>
          </template>
          <a-icon type="bulb" :style="{ color: 'blue' }" />
        </a-popover>
      </span>
    </a-table>
  </div>
</template>

<script>
export default {
  data() {
    return this.getColumns();
  },
  props: {
    tableName: String,
    tableData: Array,
    tableKey: String,
  },
  methods: {
    download: function (url) {
      window.open("download.php?name=" + url);
    },
    getColumns: function () {
      if (this.tableKey == 1) {
        return {
          columns: [
            {
              title: "版本声明",
              dataIndex: "statement",
              key: "statement",
              width: "18%",
              align: "center",
              scopedSlots: { customRender: "popover" },
            },
            {
              title: "文件名称",
              dataIndex: "fileName",
              key: "fileName",
              width: "26%",
            },
            {
              title: "上传时间",
              key: "uploadDate",
              dataIndex: "uploadDate",
              align: "center",
              width: "18%",
            },
            {
              title: "文件大小",
              key: "fileSize",
              dataIndex: "fileSize",
              align: "center",
              width: "18%",
            },
            {
              title: "下载",
              dataIndex: "downloadUrl",
              key: "downloadUrl",
              align: "center",
              width: "20%",
              scopedSlots: { customRender: "download" },
            },
          ],
        };
      } else {
        return {
          columns: [
            {
              title: "文件名称",
              dataIndex: "fileName",
              key: "fileName",
              width: "26%",
            },
            {
              title: "上传时间",
              key: "uploadDate",
              dataIndex: "uploadDate",
              align: "center",
              width: "18%",
            },
            {
              title: "文件大小",
              key: "fileSize",
              dataIndex: "fileSize",
              align: "center",
              width: "18%",
            },
            {
              title: "下载",
              dataIndex: "downloadUrl",
              key: "downloadUrl",
              align: "center",
              width: "20%",
              scopedSlots: { customRender: "download" },
            },
          ],
        };
      }
    },
  },
};
</script>

<style>
.ant-tabs-bar {
  margin-bottom: 32px !important;
}
</style>